import Peer from "peerjs";
export default class ReceiverConnection {
    constructor(onPlayerOpen, onPlayerMessage, onPlayerClose, callback) {
        this.onPlayerOpen = onPlayerOpen
        this.onPlayerMessage = onPlayerMessage
        this.onPlayerClose = onPlayerClose
        this.peerId = ""
        this.lastPeerId = ""
        this.conn = null;
        this.createSelf(callback)
    }
    additionalListeners = []

    addListener(listenerName, listenerMethod){
        this.additionalListeners.push({name:listenerName, listenerMethod})
        console.log("added listener", this.additionalListeners,)
    }
    
    removeListener(listenerName){
        console.log("remove listener", this.additionalListeners)
        let index = this.additionalListeners.find(listener=> listener.name == listenerName)
        if(index != -1){
            this.additionalListeners.splice(index,1)
        }
    }

    async createSelf(callback) {
        // if(retries == 0){

        // }
        // this.peer = await new Promise(resolve => {
        //     resolve(new Peer({
        //         secure:true,
        //         host: 'akashicf-paths-peer-server.herokuapp.com',
        //         port: 443
        //    })
        //     )
        // })

        this.peer = await new Promise(resolve => {
            console.log("started resolve")
            resolve(new Peer({ debug:2, config: {'iceServers': [
                    { url: "stun:stun.l.google.com:19302" },
                    { url: "stun:stun1.l.google.com:19302" },
                    //{ urls: "stun:stun.relay.metered.ca:80"},
              {
                urls: "turn:a.relay.metered.ca:80",
                username: "48995fe759ac8acd37a7da1a",
                credential: "mMQC9m3b/AuYgSdS",
              },
              {
                urls: "turn:a.relay.metered.ca:80?transport=tcp",
                username: "48995fe759ac8acd37a7da1a",
                credential: "mMQC9m3b/AuYgSdS",
              },
              {
                urls: "turn:a.relay.metered.ca:443",
                username: "48995fe759ac8acd37a7da1a",
                credential: "mMQC9m3b/AuYgSdS",
              },
              {
                urls: "turn:a.relay.metered.ca:443?transport=tcp",
                username: "48995fe759ac8acd37a7da1a",
                credential: "mMQC9m3b/AuYgSdS",
              },
                  ]}})
            )
            console.log("end resolve")
        })
        // this.peer.on("error", async function(err){
        //     console.log("error with server, trying backup", err)
        //     this.peer = await new Promise(resolve => {
        //         resolve(new Peer({
        //             secure:true,
        //             host: 'akashic-paths-peer-server.herokuapp.com',
        //             port: 443
        //        })
        //         )
        //     })
        // })
            
        
        this.peer.on('open', ()=> {
            console.log("new peer open")
            // Workaround for peer.reconnect deleting previous id
            if (this.peer.id === null) {
                console.log('Received null id from peer open');
                this.peer.id = this.lastPeerId;
            } else {
                this.lastPeerId = this.peer.id;
            }
            callback()
            console.log('ID: ' + this.peer.id);
        });

        this.peer.on('connection', (c) => {
            // Allow only a single connection
            if (this.conn && this.conn.open) {
                c.on('open', function () {
                    c.send("Already connected to another client");
                    setTimeout(function () { c.close(); }, 500);
                });
                return;
            }
            this.onPlayerOpen()

            this.conn = c;
            console.log("Connected to: " + this.conn.peer);
            this.conn.on('data', (data) => {
                console.log("Data recieved", data);
                this.onPlayerMessage(data)
                if(this.additionalListeners.length > 0){
                    this.additionalListeners.forEach(listener => {
                        listener.listenerMethod(data)
                    })
                }
            })
    
            this.conn.on('close', () => {
                this.onPlayerClose()
                console.log("connection closed")
                this.conn = null;
            });
        });

        this.peer.on('disconnected', function () {
            console.log('Connection lost. Please reconnect');

            // Workaround for peer.reconnect deleting previous id
            this.peer.id = this.lastPeerId;
            this.peer._lastServerId = this.lastPeerId;
            this.peer.reconnect();
        });

        this.peer.on('close', function () {
            this.conn = null;
            console.log('Connection destroyed');
        });

        this.peer.on('error', function (err) {
            console.log(err);
            //alert('' + err);
        });
    }


    getId() {
        return this.peer.id
    }

    send(message){
        this.conn.send(message)
    }
}